import humps from 'humps';

function camelChecker(key, convert) {
	// Do not convert keys with hyphens
	// `cat_tree` for example is keyed by slugs & we no want camel there...
	return key.includes("-") ? key : convert(key);
}

export function getDataSegment(data, segment = '', defaultValue = null, options = {}) {
	let { autoHumps } = options;
	autoHumps = autoHumps !== false; // default true

	if (!data) return defaultValue;
	if (!segment) return autoHumps ? humps.camelizeKeys(data, camelChecker) : data;
	if (typeof data[segment] === "undefined") return defaultValue;

	return autoHumps ? humps.camelizeKeys(data[segment], camelChecker) : data[segment];
}

export default function getAppData(segment = '', defaultValue = null, options = {}) {
	if (typeof window !== "object" || !window.cj.app_data) return defaultValue;

	if(segment === 'listing') {
		const appData = window.cj.app_data || {};
		return getDataSegment(appData, segment, defaultValue, options);
	}
	const appData = window.cj.app_data || {};
	return getDataSegment(appData, segment, defaultValue, options);
}

export function getCustomData(data, defaultValue = null, options = {}) {
	if (typeof window !== "object" || !data) return defaultValue;
	return getDataSegment(data, '', defaultValue, options);
}

export function getListingData(segment = '', defaultValue = null) {
	if (typeof window !== "object") return defaultValue;
	const listingData = window?.cj?.listing;
	if(listingData === undefined) {
		return defaultValue;
	}
	return getDataSegment(listingData, segment, defaultValue);
}
